<template>
    <div>
        <ui-select
            :icon="icon"
            :label="label"
            :keys="{ label:'name', value: 'id' }"
            :placeholder="placeholder"

            :options="options"
            :disabled="isLoading || disabled"
            v-model="selected"
            @change="handleChange"
        ></ui-select>
    </div>
</template>

<script>    
    import { LocationResource } from '../../../classes/Api/Location'

    export default {
        props: {
            icon: {
                type: String
            },
            label: {
                type: String,
            },
            value: {
                type: Object,
            },
            disabled: {
                type: Boolean,
                default: false
            },
            relationsToLoad: {
                type: Array,
                default() {
                    return []
                }
            },
            placeholder: {
                type: String,
                default: 'Select location'
            }
        },
        watch: {
            value: {
                handler(newVal) {
                    this.selected = newVal;
                },
                deep: true,
            }
        },
        data() {
            return {
                selected: {},
                options: [],
                isLoading: true,
            }
        },
        mounted() {
            this.isLoading = true;

            this.selected = this.value ?? {};

            LocationResource.all({ with: this.relationsToLoad }).then(response => {
                this.isLoading = false;

                this.options = Array.isArray(response.data) ? response.data : [];
            })
        },
        methods: {
            handleChange(e) {
                this.$emit('input', e);
            }
        }
    }
</script>